import { useMemo } from "react";
import {
  CreateCartPayload,
  WarrantyPackageVoucher,
} from "shared/api/middleware-api-client";
import { useWarrantyData } from "./useWarrantyData";

export function useWarrantyVoucherData({
  cartValue,
  voucherWarranties,
  enabled = true,
}: {
  cartValue: CreateCartPayload;
  voucherWarranties: WarrantyPackageVoucher[] | undefined;
  enabled?: boolean;
}) {
  const { warrantyPackagesDataRequest, warranties } = useWarrantyData(enabled);

  const checkoutWarranties = useMemo(() => {
    if (!warrantyPackagesDataRequest.data) return [];

    const warrantiesList = [
      ...(warrantyPackagesDataRequest.data.payNowPackages ?? []),
      warranties.noWarrantyPayNowPackage,
    ];

    if (!cartValue.isSelfAssembly)
      warrantiesList.push(warranties.decideLaterWarrantyPackage);

    return warrantiesList;
  }, [warranties, warrantyPackagesDataRequest.data]);

  const voucherWarrantyPackage = useMemo(() => {
    if (!voucherWarranties || voucherWarranties?.length <= 0) return undefined;
    return (
      checkoutWarranties.find((pkg) =>
        voucherWarranties.some((vw) => vw.id === pkg.packageId),
      ) ?? undefined
    );
  }, [checkoutWarranties, voucherWarranties]);

  return {
    warrantyPackagesDataRequest,
    checkoutWarranties,
    voucherWarrantyPackage,
    warranties,
  };
}
